import Fetcher from '../common/communicate';

export default function publisher(event, callback) {
    if (!event.currentTarget.dataset) {
        return false;
    }

    const {
        published, id, type, article,
    } = event.currentTarget.dataset;

    const genre = article ? 'articles' : type;
    const articleType = article ? `${type}/` : '';
    const action = published === 'true' ? 'unpublish' : 'publish';

    const url = `${genre}/${articleType}${id}/${action}/`;

    Fetcher(url, 'POST', callback);
}
